import React, { useRef, useEffect } from "react";
import { Space, Button, Input, Checkbox } from "antd";
import { DatePicker } from "../../../components/antOverrides";
import moment from "moment";
import { Select } from "antd";
import { useIntl } from "react-intl";
import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import { changeTimeFrame, changeBranch, setShowInactive } from "../assetsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import { hasAccessTo } from "../../../hooks/accessControl";
const { Option } = Select;
const { RangePicker } = DatePicker;

const Header = (props) => {
  const { onTextChange, textFilter, reload, entityId } = props;
  const intl = useIntl();
  let location = useLocation();
  let { branchId } = useParams();

  const inputRef = useRef();
  const dispatch = useDispatch();
  const direction = useSelector(
    (state) => state.user.currentAppLocale.direction
  );
  const { activeBranch, showInactive } = useSelector((state) => state.assets);
  const profile = useSelector((state) => state.user.profile);

  useEffect(() => {
    if (inputRef && inputRef.current) {
      const { input } = inputRef.current;
      input.focus();
    }
  }, []);
  const onChange = (val) => {
    let from = null;
    let to = null;
    if (val) {
      from = moment(val[0]).startOf("day").format();
      to = moment(val[1]).endOf("day").format();
    }
    dispatch(changeTimeFrame(from, to));
  };

  const isAdmin = location.pathname.includes("admin");

  const onBranchChange = (branch) => {
    dispatch(changeBranch(branch));
  };

  const reloadData = () => {
    dispatch(reload());
  };
  const branch = activeBranch || +branchId;
  const hasRestoreAccess = hasAccessTo(profile, branch, "assets", "restore");
  const onCheckboxChange = (e) => {
    dispatch(setShowInactive(e.target.checked));
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: "10px",
      }}
    >
      <Space direction="horizontal">
        <Input
          prefix={
            <SearchOutlined style={{ padding: "0  5px", opacity: 0.4 }} />
          }
          placeholder={intl.formatMessage({
            id: `app.assets.search_by_name_or_entity`,
          })}
          value={textFilter}
          onChange={onTextChange}
          style={{ width: 300 }}
          allowClear
          ref={inputRef}
        />

        <RangePicker onChange={onChange} />

        {isAdmin && !entityId ? (
          <Select
            style={{ width: "200px" }}
            defaultValue={branchId ? parseInt(branchId) : undefined}
            showSearch
            placeholder={intl.formatMessage({
              id: "app.users.chooseBranch",
            })}
            optionFilterProp="children"
            onChange={onBranchChange}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            value={activeBranch}
            allowClear
          >
            {profile.branches
              ? profile.branches.map((b) => (
                  <Option value={b.id} key={b.id}>
                    {b.name}
                  </Option>
                ))
              : null}
          </Select>
        ) : null}
        {hasRestoreAccess ? (
          <Checkbox
            style={{ margin: "0 20px" }}
            onChange={onCheckboxChange}
            checked={showInactive}
          >
            {intl.formatMessage({
              id: "app.employees.showInactive",
            })}
          </Checkbox>
        ) : null}
      </Space>
      <Button
        type="text"
        onClick={reloadData}
        size="large"
        shape="circle"
        icon={
          <ReloadOutlined
            className={direction === "rtl" ? "reloadRtl" : "reload"}
          />
        }
      />
    </div>
  );
};

export default Header;
